import ScrollReveal from '@/components/ScrollReveal';

const serviceLinks = [
  'Conventional Bonds', 'Sukuk & Islamic Finance', 'Green & ESG Bonds',
  'Private Placements', 'Project Finance', 'Liability Management',
];

const companyLinks = [
  { label: 'About Us', href: '#why-us' },
  { label: 'Our Process', href: '#process' },
  { label: 'Sectors', href: '#sectors' },
  { label: 'Technology', href: '#technology' },
  { label: 'Contact', href: '#contact' },
];

export default function Footer() {
  const scrollTo = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{ backgroundColor: '#060f1d' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
        <ScrollReveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-8">
            {/* Brand */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div
                  className="w-9 h-9 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: '#0f2240', border: '1px solid rgba(201,168,76,0.3)' }}
                >
                  <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                    <path d="M4 16V4L10 10L16 4V16" stroke="#c9a84c" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <span className="font-playfair text-xl font-bold tracking-tight">
                  <span className="text-white">ALC</span>
                  <span style={{ color: '#c9a84c' }}>BOND</span>
                </span>
              </div>
              <p className="font-inter text-sm leading-relaxed" style={{ color: '#6b7280' }}>
                Premier bond arranger and debt capital markets structurer operating from DIFC and ADGM. Structuring conventional bonds, sukuk, and innovative financing instruments.
              </p>
            </div>

            {/* Services */}
            <div>
              <h4 className="font-inter font-semibold text-white text-sm mb-4">Services</h4>
              <ul className="space-y-2.5">
                {serviceLinks.map(link => (
                  <li key={link}>
                    <a
                      href="#services"
                      onClick={(e) => scrollTo(e, '#services')}
                      className="font-inter text-sm"
                      style={{ color: '#6b7280', transition: 'color 200ms' }}
                      onMouseEnter={(e) => e.target.style.color = '#c9a84c'}
                      onMouseLeave={(e) => e.target.style.color = '#6b7280'}
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company */}
            <div>
              <h4 className="font-inter font-semibold text-white text-sm mb-4">Company</h4>
              <ul className="space-y-2.5">
                {companyLinks.map(({ label, href }) => (
                  <li key={label}>
                    <a
                      href={href}
                      onClick={(e) => scrollTo(e, href)}
                      className="font-inter text-sm"
                      style={{ color: '#6b7280', transition: 'color 200ms' }}
                      onMouseEnter={(e) => e.target.style.color = '#c9a84c'}
                      onMouseLeave={(e) => e.target.style.color = '#6b7280'}
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </ScrollReveal>
      </div>

      {/* Bottom Bar */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 space-y-3">
          <p className="font-inter text-xs leading-relaxed" style={{ color: '#6b7280' }}>
            This website is directed at Professional Clients and Market Counterparties. It does not constitute investment advice or an offer to buy or sell any financial instrument.
          </p>
          <p className="font-inter text-xs" style={{ color: '#6b7280' }}>
            &copy; 2026 ALC Bond Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
